module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-cdu-seleziona-particelle",
      "title": "Cdu Seleziona Particelle"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56793d38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/CduSelezionaParticelle.vue
// module id = 871
// module chunks = 39